import moment from 'moment';
import 'moment/locale/da';
import 'moment/locale/en-gb';
import {TranslatedLanguage} from 'hubbl-shared';
import {getInitialLanguage} from '../i18n';

export const setMomentLocale = (language: TranslatedLanguage) => {
  switch (language) {
    case TranslatedLanguage.Danish:
      moment.locale('da');
      break;
    case TranslatedLanguage.English:
    default:
      moment.locale('en-gb');
      break;
  }
};

// Initialize with language priority: localStorage -> browser -> English
setMomentLocale(getInitialLanguage());
